import * as React from "react";

// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import { memoizeFunction } from "@fluentui/react";

export const ShadowRenderingContext = React.createContext({
  isShadowRendering: false,
});
ShadowRenderingContext.displayName = "ShadowRenderingContext";

/**
 * This will be used to set the value of shadow rendering context by providers.
 * Memoizing is important for this because of https://reactjs.org/docs/context.html#caveats
 */
export const getShadowRenderingContextValue = memoizeFunction(
  (isShadowRendering: boolean) => {
    return {
      isShadowRendering,
    };
  }
);
